var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Editar File")]),_c('b-card',[_c('FormEdit',{on:{"saved":_vm.loadData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }